import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default () => ({
  path: ":recordId",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "external-assessment-record-details" */ "./components"
      ),
    ]).then(([importedModule0]) => importedModule0.default)
  ),
});
